<div class="table-container">
  <ng-template #container></ng-template>
</div>
